/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as MainImport } from './routes/_main'
import { Route as BlankImport } from './routes/_blank'
import { Route as MainIndexImport } from './routes/_main/index'
import { Route as MainSecurityImport } from './routes/_main/security'
import { Route as MainPricingImport } from './routes/_main/pricing'
import { Route as MainDucksImport } from './routes/_main/ducks'
import { Route as MainContactImport } from './routes/_main/contact'
import { Route as MainAboutImport } from './routes/_main/about'
import { Route as BlankStyleGuideImport } from './routes/_blank/style-guide'
import { Route as BlankSignupImport } from './routes/_blank/signup'
import { Route as MainCustomersIndexImport } from './routes/_main/customers/index'
import { Route as MainChangelogIndexImport } from './routes/_main/changelog/index'
import { Route as MainCareersIndexImport } from './routes/_main/careers/index'
import { Route as MainBlogIndexImport } from './routes/_main/blog/index'
import { Route as MainLegalIdImport } from './routes/_main/legal.$id'
import { Route as MainCustomersStoryIdImport } from './routes/_main/customers/$storyId'
import { Route as BlankSignupConfirmationImport } from './routes/_blank/signup_.confirmation'
import { Route as BlankBookingIdImport } from './routes/_blank/booking.$id'
import { Route as MainChangelogEntriesIdImport } from './routes/_main/changelog/entries.$id'
import { Route as MainBlogPostsPostIdImport } from './routes/_main/blog/posts.$postId'
import { Route as BlankBookingIdConfirmationImport } from './routes/_blank/booking_.$id.confirmation'

// Create/Update Routes

const MainRoute = MainImport.update({
  id: '/_main',
  getParentRoute: () => rootRoute,
} as any)

const BlankRoute = BlankImport.update({
  id: '/_blank',
  getParentRoute: () => rootRoute,
} as any)

const MainIndexRoute = MainIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any)

const MainSecurityRoute = MainSecurityImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => MainRoute,
} as any)

const MainPricingRoute = MainPricingImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MainRoute,
} as any)

const MainDucksRoute = MainDucksImport.update({
  id: '/ducks',
  path: '/ducks',
  getParentRoute: () => MainRoute,
} as any)

const MainContactRoute = MainContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MainRoute,
} as any)

const MainAboutRoute = MainAboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MainRoute,
} as any)

const BlankStyleGuideRoute = BlankStyleGuideImport.update({
  id: '/style-guide',
  path: '/style-guide',
  getParentRoute: () => BlankRoute,
} as any)

const BlankSignupRoute = BlankSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => BlankRoute,
} as any)

const MainCustomersIndexRoute = MainCustomersIndexImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => MainRoute,
} as any)

const MainChangelogIndexRoute = MainChangelogIndexImport.update({
  id: '/changelog/',
  path: '/changelog/',
  getParentRoute: () => MainRoute,
} as any)

const MainCareersIndexRoute = MainCareersIndexImport.update({
  id: '/careers/',
  path: '/careers/',
  getParentRoute: () => MainRoute,
} as any)

const MainBlogIndexRoute = MainBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => MainRoute,
} as any)

const MainLegalIdRoute = MainLegalIdImport.update({
  id: '/legal/$id',
  path: '/legal/$id',
  getParentRoute: () => MainRoute,
} as any)

const MainCustomersStoryIdRoute = MainCustomersStoryIdImport.update({
  id: '/customers/$storyId',
  path: '/customers/$storyId',
  getParentRoute: () => MainRoute,
} as any)

const BlankSignupConfirmationRoute = BlankSignupConfirmationImport.update({
  id: '/signup_/confirmation',
  path: '/signup/confirmation',
  getParentRoute: () => BlankRoute,
} as any)

const BlankBookingIdRoute = BlankBookingIdImport.update({
  id: '/booking/$id',
  path: '/booking/$id',
  getParentRoute: () => BlankRoute,
} as any)

const MainChangelogEntriesIdRoute = MainChangelogEntriesIdImport.update({
  id: '/changelog/entries/$id',
  path: '/changelog/entries/$id',
  getParentRoute: () => MainRoute,
} as any)

const MainBlogPostsPostIdRoute = MainBlogPostsPostIdImport.update({
  id: '/blog/posts/$postId',
  path: '/blog/posts/$postId',
  getParentRoute: () => MainRoute,
} as any)

const BlankBookingIdConfirmationRoute = BlankBookingIdConfirmationImport.update(
  {
    id: '/booking_/$id/confirmation',
    path: '/booking/$id/confirmation',
    getParentRoute: () => BlankRoute,
  } as any,
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_blank': {
      id: '/_blank'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BlankImport
      parentRoute: typeof rootRoute
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainImport
      parentRoute: typeof rootRoute
    }
    '/_blank/signup': {
      id: '/_blank/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof BlankSignupImport
      parentRoute: typeof BlankImport
    }
    '/_blank/style-guide': {
      id: '/_blank/style-guide'
      path: '/style-guide'
      fullPath: '/style-guide'
      preLoaderRoute: typeof BlankStyleGuideImport
      parentRoute: typeof BlankImport
    }
    '/_main/about': {
      id: '/_main/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MainAboutImport
      parentRoute: typeof MainImport
    }
    '/_main/contact': {
      id: '/_main/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof MainContactImport
      parentRoute: typeof MainImport
    }
    '/_main/ducks': {
      id: '/_main/ducks'
      path: '/ducks'
      fullPath: '/ducks'
      preLoaderRoute: typeof MainDucksImport
      parentRoute: typeof MainImport
    }
    '/_main/pricing': {
      id: '/_main/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof MainPricingImport
      parentRoute: typeof MainImport
    }
    '/_main/security': {
      id: '/_main/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof MainSecurityImport
      parentRoute: typeof MainImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexImport
      parentRoute: typeof MainImport
    }
    '/_blank/booking/$id': {
      id: '/_blank/booking/$id'
      path: '/booking/$id'
      fullPath: '/booking/$id'
      preLoaderRoute: typeof BlankBookingIdImport
      parentRoute: typeof BlankImport
    }
    '/_blank/signup_/confirmation': {
      id: '/_blank/signup_/confirmation'
      path: '/signup/confirmation'
      fullPath: '/signup/confirmation'
      preLoaderRoute: typeof BlankSignupConfirmationImport
      parentRoute: typeof BlankImport
    }
    '/_main/customers/$storyId': {
      id: '/_main/customers/$storyId'
      path: '/customers/$storyId'
      fullPath: '/customers/$storyId'
      preLoaderRoute: typeof MainCustomersStoryIdImport
      parentRoute: typeof MainImport
    }
    '/_main/legal/$id': {
      id: '/_main/legal/$id'
      path: '/legal/$id'
      fullPath: '/legal/$id'
      preLoaderRoute: typeof MainLegalIdImport
      parentRoute: typeof MainImport
    }
    '/_main/blog/': {
      id: '/_main/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof MainBlogIndexImport
      parentRoute: typeof MainImport
    }
    '/_main/careers/': {
      id: '/_main/careers/'
      path: '/careers'
      fullPath: '/careers'
      preLoaderRoute: typeof MainCareersIndexImport
      parentRoute: typeof MainImport
    }
    '/_main/changelog/': {
      id: '/_main/changelog/'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof MainChangelogIndexImport
      parentRoute: typeof MainImport
    }
    '/_main/customers/': {
      id: '/_main/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof MainCustomersIndexImport
      parentRoute: typeof MainImport
    }
    '/_blank/booking_/$id/confirmation': {
      id: '/_blank/booking_/$id/confirmation'
      path: '/booking/$id/confirmation'
      fullPath: '/booking/$id/confirmation'
      preLoaderRoute: typeof BlankBookingIdConfirmationImport
      parentRoute: typeof BlankImport
    }
    '/_main/blog/posts/$postId': {
      id: '/_main/blog/posts/$postId'
      path: '/blog/posts/$postId'
      fullPath: '/blog/posts/$postId'
      preLoaderRoute: typeof MainBlogPostsPostIdImport
      parentRoute: typeof MainImport
    }
    '/_main/changelog/entries/$id': {
      id: '/_main/changelog/entries/$id'
      path: '/changelog/entries/$id'
      fullPath: '/changelog/entries/$id'
      preLoaderRoute: typeof MainChangelogEntriesIdImport
      parentRoute: typeof MainImport
    }
  }
}

// Create and export the route tree

interface BlankRouteChildren {
  BlankSignupRoute: typeof BlankSignupRoute
  BlankStyleGuideRoute: typeof BlankStyleGuideRoute
  BlankBookingIdRoute: typeof BlankBookingIdRoute
  BlankSignupConfirmationRoute: typeof BlankSignupConfirmationRoute
  BlankBookingIdConfirmationRoute: typeof BlankBookingIdConfirmationRoute
}

const BlankRouteChildren: BlankRouteChildren = {
  BlankSignupRoute: BlankSignupRoute,
  BlankStyleGuideRoute: BlankStyleGuideRoute,
  BlankBookingIdRoute: BlankBookingIdRoute,
  BlankSignupConfirmationRoute: BlankSignupConfirmationRoute,
  BlankBookingIdConfirmationRoute: BlankBookingIdConfirmationRoute,
}

const BlankRouteWithChildren = BlankRoute._addFileChildren(BlankRouteChildren)

interface MainRouteChildren {
  MainAboutRoute: typeof MainAboutRoute
  MainContactRoute: typeof MainContactRoute
  MainDucksRoute: typeof MainDucksRoute
  MainPricingRoute: typeof MainPricingRoute
  MainSecurityRoute: typeof MainSecurityRoute
  MainIndexRoute: typeof MainIndexRoute
  MainCustomersStoryIdRoute: typeof MainCustomersStoryIdRoute
  MainLegalIdRoute: typeof MainLegalIdRoute
  MainBlogIndexRoute: typeof MainBlogIndexRoute
  MainCareersIndexRoute: typeof MainCareersIndexRoute
  MainChangelogIndexRoute: typeof MainChangelogIndexRoute
  MainCustomersIndexRoute: typeof MainCustomersIndexRoute
  MainBlogPostsPostIdRoute: typeof MainBlogPostsPostIdRoute
  MainChangelogEntriesIdRoute: typeof MainChangelogEntriesIdRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainAboutRoute: MainAboutRoute,
  MainContactRoute: MainContactRoute,
  MainDucksRoute: MainDucksRoute,
  MainPricingRoute: MainPricingRoute,
  MainSecurityRoute: MainSecurityRoute,
  MainIndexRoute: MainIndexRoute,
  MainCustomersStoryIdRoute: MainCustomersStoryIdRoute,
  MainLegalIdRoute: MainLegalIdRoute,
  MainBlogIndexRoute: MainBlogIndexRoute,
  MainCareersIndexRoute: MainCareersIndexRoute,
  MainChangelogIndexRoute: MainChangelogIndexRoute,
  MainCustomersIndexRoute: MainCustomersIndexRoute,
  MainBlogPostsPostIdRoute: MainBlogPostsPostIdRoute,
  MainChangelogEntriesIdRoute: MainChangelogEntriesIdRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof MainRouteWithChildren
  '/signup': typeof BlankSignupRoute
  '/style-guide': typeof BlankStyleGuideRoute
  '/about': typeof MainAboutRoute
  '/contact': typeof MainContactRoute
  '/ducks': typeof MainDucksRoute
  '/pricing': typeof MainPricingRoute
  '/security': typeof MainSecurityRoute
  '/': typeof MainIndexRoute
  '/booking/$id': typeof BlankBookingIdRoute
  '/signup/confirmation': typeof BlankSignupConfirmationRoute
  '/customers/$storyId': typeof MainCustomersStoryIdRoute
  '/legal/$id': typeof MainLegalIdRoute
  '/blog': typeof MainBlogIndexRoute
  '/careers': typeof MainCareersIndexRoute
  '/changelog': typeof MainChangelogIndexRoute
  '/customers': typeof MainCustomersIndexRoute
  '/booking/$id/confirmation': typeof BlankBookingIdConfirmationRoute
  '/blog/posts/$postId': typeof MainBlogPostsPostIdRoute
  '/changelog/entries/$id': typeof MainChangelogEntriesIdRoute
}

export interface FileRoutesByTo {
  '': typeof BlankRouteWithChildren
  '/signup': typeof BlankSignupRoute
  '/style-guide': typeof BlankStyleGuideRoute
  '/about': typeof MainAboutRoute
  '/contact': typeof MainContactRoute
  '/ducks': typeof MainDucksRoute
  '/pricing': typeof MainPricingRoute
  '/security': typeof MainSecurityRoute
  '/': typeof MainIndexRoute
  '/booking/$id': typeof BlankBookingIdRoute
  '/signup/confirmation': typeof BlankSignupConfirmationRoute
  '/customers/$storyId': typeof MainCustomersStoryIdRoute
  '/legal/$id': typeof MainLegalIdRoute
  '/blog': typeof MainBlogIndexRoute
  '/careers': typeof MainCareersIndexRoute
  '/changelog': typeof MainChangelogIndexRoute
  '/customers': typeof MainCustomersIndexRoute
  '/booking/$id/confirmation': typeof BlankBookingIdConfirmationRoute
  '/blog/posts/$postId': typeof MainBlogPostsPostIdRoute
  '/changelog/entries/$id': typeof MainChangelogEntriesIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_blank': typeof BlankRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_blank/signup': typeof BlankSignupRoute
  '/_blank/style-guide': typeof BlankStyleGuideRoute
  '/_main/about': typeof MainAboutRoute
  '/_main/contact': typeof MainContactRoute
  '/_main/ducks': typeof MainDucksRoute
  '/_main/pricing': typeof MainPricingRoute
  '/_main/security': typeof MainSecurityRoute
  '/_main/': typeof MainIndexRoute
  '/_blank/booking/$id': typeof BlankBookingIdRoute
  '/_blank/signup_/confirmation': typeof BlankSignupConfirmationRoute
  '/_main/customers/$storyId': typeof MainCustomersStoryIdRoute
  '/_main/legal/$id': typeof MainLegalIdRoute
  '/_main/blog/': typeof MainBlogIndexRoute
  '/_main/careers/': typeof MainCareersIndexRoute
  '/_main/changelog/': typeof MainChangelogIndexRoute
  '/_main/customers/': typeof MainCustomersIndexRoute
  '/_blank/booking_/$id/confirmation': typeof BlankBookingIdConfirmationRoute
  '/_main/blog/posts/$postId': typeof MainBlogPostsPostIdRoute
  '/_main/changelog/entries/$id': typeof MainChangelogEntriesIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/signup'
    | '/style-guide'
    | '/about'
    | '/contact'
    | '/ducks'
    | '/pricing'
    | '/security'
    | '/'
    | '/booking/$id'
    | '/signup/confirmation'
    | '/customers/$storyId'
    | '/legal/$id'
    | '/blog'
    | '/careers'
    | '/changelog'
    | '/customers'
    | '/booking/$id/confirmation'
    | '/blog/posts/$postId'
    | '/changelog/entries/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/signup'
    | '/style-guide'
    | '/about'
    | '/contact'
    | '/ducks'
    | '/pricing'
    | '/security'
    | '/'
    | '/booking/$id'
    | '/signup/confirmation'
    | '/customers/$storyId'
    | '/legal/$id'
    | '/blog'
    | '/careers'
    | '/changelog'
    | '/customers'
    | '/booking/$id/confirmation'
    | '/blog/posts/$postId'
    | '/changelog/entries/$id'
  id:
    | '__root__'
    | '/_blank'
    | '/_main'
    | '/_blank/signup'
    | '/_blank/style-guide'
    | '/_main/about'
    | '/_main/contact'
    | '/_main/ducks'
    | '/_main/pricing'
    | '/_main/security'
    | '/_main/'
    | '/_blank/booking/$id'
    | '/_blank/signup_/confirmation'
    | '/_main/customers/$storyId'
    | '/_main/legal/$id'
    | '/_main/blog/'
    | '/_main/careers/'
    | '/_main/changelog/'
    | '/_main/customers/'
    | '/_blank/booking_/$id/confirmation'
    | '/_main/blog/posts/$postId'
    | '/_main/changelog/entries/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  BlankRoute: typeof BlankRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  BlankRoute: BlankRouteWithChildren,
  MainRoute: MainRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_blank",
        "/_main"
      ]
    },
    "/_blank": {
      "filePath": "_blank.tsx",
      "children": [
        "/_blank/signup",
        "/_blank/style-guide",
        "/_blank/booking/$id",
        "/_blank/signup_/confirmation",
        "/_blank/booking_/$id/confirmation"
      ]
    },
    "/_main": {
      "filePath": "_main.tsx",
      "children": [
        "/_main/about",
        "/_main/contact",
        "/_main/ducks",
        "/_main/pricing",
        "/_main/security",
        "/_main/",
        "/_main/customers/$storyId",
        "/_main/legal/$id",
        "/_main/blog/",
        "/_main/careers/",
        "/_main/changelog/",
        "/_main/customers/",
        "/_main/blog/posts/$postId",
        "/_main/changelog/entries/$id"
      ]
    },
    "/_blank/signup": {
      "filePath": "_blank/signup.tsx",
      "parent": "/_blank"
    },
    "/_blank/style-guide": {
      "filePath": "_blank/style-guide.tsx",
      "parent": "/_blank"
    },
    "/_main/about": {
      "filePath": "_main/about.tsx",
      "parent": "/_main"
    },
    "/_main/contact": {
      "filePath": "_main/contact.tsx",
      "parent": "/_main"
    },
    "/_main/ducks": {
      "filePath": "_main/ducks.tsx",
      "parent": "/_main"
    },
    "/_main/pricing": {
      "filePath": "_main/pricing.tsx",
      "parent": "/_main"
    },
    "/_main/security": {
      "filePath": "_main/security.tsx",
      "parent": "/_main"
    },
    "/_main/": {
      "filePath": "_main/index.tsx",
      "parent": "/_main"
    },
    "/_blank/booking/$id": {
      "filePath": "_blank/booking.$id.tsx",
      "parent": "/_blank"
    },
    "/_blank/signup_/confirmation": {
      "filePath": "_blank/signup_.confirmation.tsx",
      "parent": "/_blank"
    },
    "/_main/customers/$storyId": {
      "filePath": "_main/customers/$storyId.tsx",
      "parent": "/_main"
    },
    "/_main/legal/$id": {
      "filePath": "_main/legal.$id.tsx",
      "parent": "/_main"
    },
    "/_main/blog/": {
      "filePath": "_main/blog/index.tsx",
      "parent": "/_main"
    },
    "/_main/careers/": {
      "filePath": "_main/careers/index.tsx",
      "parent": "/_main"
    },
    "/_main/changelog/": {
      "filePath": "_main/changelog/index.tsx",
      "parent": "/_main"
    },
    "/_main/customers/": {
      "filePath": "_main/customers/index.tsx",
      "parent": "/_main"
    },
    "/_blank/booking_/$id/confirmation": {
      "filePath": "_blank/booking_.$id.confirmation.tsx",
      "parent": "/_blank"
    },
    "/_main/blog/posts/$postId": {
      "filePath": "_main/blog/posts.$postId.tsx",
      "parent": "/_main"
    },
    "/_main/changelog/entries/$id": {
      "filePath": "_main/changelog/entries.$id.tsx",
      "parent": "/_main"
    }
  }
}
ROUTE_MANIFEST_END */
